export default __webpack_public_path__ + "static/media/audio_02_lobos_marinos.62c61084.mp3";